import angular from 'angular';
import { keys } from 'lodash';

module.exports = angular.module('common.filters.sorted-keys', [])
.filter('sortedKeys', () => {
  return (object) => {
    return keys(object).sort();
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/sorted-keys.js
 **/